import React from 'react';

const F = "'Inter', system-ui, sans-serif";

// ⚠️  BITTE VOR DEM LIVEGANG AUSFÜLLEN:
//     - OPERATOR_NAME: Vor- und Zuname des Betreibers (Pflicht nach ECG §5)
//     - OPERATOR_STREET: Echte Adresse
//     - OPERATOR_ZIP_CITY: PLZ und Ort
//     - OPERATOR_PHONE: Telefonnummer
//     - Ggf. UID-Nummer, Gewerbeschein-Behörde

const OPERATOR_NAME    = 'Vorname Nachname';         // ← AUSFÜLLEN
const OPERATOR_STREET  = 'Straße Hausnummer';         // ← AUSFÜLLEN
const OPERATOR_ZIP     = '6XXX Musterort';            // ← AUSFÜLLEN
const OPERATOR_PHONE   = '+43 XXX XXXXXX';            // ← AUSFÜLLEN
const OPERATOR_EMAIL   = 'lechcamping@tnr.at';
const BUSINESS_NAME    = 'Lechcamping Spirkenhof';

export default function Impressum() {
  return (
    <main style={styles.page}>
      <div style={styles.pageHeader}>
        <div style={styles.pageHeaderInner}>
          <span style={styles.eyebrow}>Rechtliches</span>
          <h1 style={styles.heading}>Impressum</h1>
        </div>
      </div>

      <div style={styles.inner}>

        <Block title="Angaben gemäß ECG §5 (E-Commerce-Gesetz)">
          <p><strong>Betreiber und Medieninhaber dieser Website:</strong></p>
          <p style={styles.address}>
            {OPERATOR_NAME}<br />
            {BUSINESS_NAME}<br />
            {OPERATOR_STREET}<br />
            {OPERATOR_ZIP}<br />
            Österreich
          </p>
        </Block>

        <Block title="Kontakt">
          <Row label="Telefon:">
            <a href={`tel:${OPERATOR_PHONE}`} style={styles.link}>{OPERATOR_PHONE}</a>
          </Row>
          <Row label="E-Mail:">
            <a href={`mailto:${OPERATOR_EMAIL}`} style={styles.link}>{OPERATOR_EMAIL}</a>
          </Row>
        </Block>

        <Block title="Unternehmensgegenstand">
          <p>Betrieb eines Campingplatzes und Beherbergungsbetrieb.</p>
        </Block>

        <Block title="Aufsichtsbehörde / Gewerbebehörde">
          <p>
            Bezirkshauptmannschaft / Magistrat [ZUSTÄNDIGE BEHÖRDE EINTRAGEN]<br />
            <span style={styles.note}>(Zuständige Gewerbebehörde am Unternehmensstandort)</span>
          </p>
        </Block>

        <Block title="UID-Nummer (Umsatzsteuer-Identifikationsnummer)">
          <p>ATU [NUMMER EINTRAGEN] – <span style={styles.note}>falls vorhanden, sonst diesen Abschnitt entfernen</span></p>
        </Block>

        <Block title="Offenlegung gemäß MedienG §25">
          <p>
            <strong>Medieninhaber:</strong> {OPERATOR_NAME}, {OPERATOR_STREET}, {OPERATOR_ZIP}, Österreich<br />
            <strong>Grundlegende Richtung:</strong> Informationen zum Campingplatz {BUSINESS_NAME},
            Buchungsanfragen und Präsentation des gastronomischen Angebots.
          </p>
        </Block>

        <Block title="Haftungsausschluss">
          <p style={styles.bodyText}>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
            externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich.
          </p>
          <p style={styles.bodyText}>
            Alle Inhalte dieser Website sind urheberrechtlich geschützt. Die Vervielfältigung,
            Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
            Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </Block>

        <Block title="Online-Streitbeilegung (EU-Plattform)">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              https://ec.europa.eu/consumers/odr
            </a>
          </p>
          <p style={{ ...styles.bodyText, marginTop: '0.5rem' }}>
            Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor
            einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Block>

      </div>
    </main>
  );
}

function Block({ title, children }) {
  return (
    <section style={styles.block}>
      <h2 style={styles.blockTitle}>{title}</h2>
      <div style={styles.blockContent}>{children}</div>
    </section>
  );
}

function Row({ label, children }) {
  return (
    <p style={styles.row}>
      <span style={styles.rowLabel}>{label}</span>{' '}
      {children}
    </p>
  );
}

const styles = {
  page: { backgroundColor: 'white', minHeight: '70vh' },

  pageHeader: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    padding: '4rem 1.5rem 3.5rem',
    textAlign: 'center',
  },
  pageHeaderInner: { maxWidth: '640px', margin: '0 auto' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: { color: '#111827', fontFamily: F, fontSize: 'clamp(1.9rem,5vw,2.8rem)', fontWeight: '700', marginTop: '0.4rem', letterSpacing: '-0.3px' },

  inner: { maxWidth: '760px', margin: '0 auto', padding: '3rem 1.5rem 5rem' },

  block: { marginBottom: '2.5rem', paddingBottom: '2.5rem', borderBottom: '1px solid #f3f4f6' },
  blockTitle: { color: '#111827', fontFamily: F, fontSize: '1rem', fontWeight: '700', marginBottom: '0.85rem' },
  blockContent: { color: '#374151', fontFamily: F, fontSize: '0.95rem', lineHeight: '1.75' },
  address: { fontStyle: 'normal', lineHeight: '1.8' },
  row: { marginBottom: '0.3rem' },
  rowLabel: { fontWeight: '600', color: '#111827' },
  link: { color: '#1e8449', textDecoration: 'none' },
  bodyText: { marginBottom: '0.75rem' },
  note: { color: '#9ca3af', fontSize: '0.85rem' },
};
